/**
 * Contract applicability on the client: the filter options the Reports page and
 * the Suppliers list offer, and who may decide. Mirrors
 * server/utils/contractApplicability.js, which is what is enforced.
 */

export const CONTRACT_OPTIONS = [
  { value: 'applicable', label: 'Contract applicable' },
  { value: 'not_applicable', label: 'Contract not applicable' },
  { value: 'undecided', label: 'Contract not yet decided' },
];

export const COMPLETION_OPTIONS = [
  { value: 'completed', label: 'Completed' },
  { value: 'not_completed', label: 'Not completed' },
];

export const APPLICABILITY_LABEL = {
  applicable: 'Applicable',
  not_applicable: 'Not applicable',
};

const APPLICABILITY_ROLES = ['legal', 'super_admin'];

/**
 * Whether `user` can set applicability on `supplier` now: while it waits for a
 * contract, or to bring one marked not applicable back to the contract queue.
 */
export const canSetApplicability = (user, supplier) => {
  if (!APPLICABILITY_ROLES.includes(user?.role) || !supplier) return false;
  if (supplier.status === 'pending_contract_upload') return true;
  return supplier.status === 'completed' && supplier.contractApplicability === 'not_applicable';
};

export const optionLabel = (options, value) => options.find((o) => o.value === value)?.label || value;
